import { createFileRoute, notFound } from "@tanstack/react-router";

import { IS_DEV_SERVER } from "~/constants/envConstants.ts";

/**
 * Development tools.
 *
 * Rule: the development tools exist on the Vite dev server only. Every build answers with "not found".
 */
export const Route = createFileRoute("/_auth/dev")({
    beforeLoad: () => {
        if (!IS_DEV_SERVER) {
            throw notFound();
        }
    },
});
